import { useQuery } from "@tanstack/react-query";
import { C_API } from "@/utils/helper/api";
import Secure from "@/secure/payload";
import { API_URLS } from "@/utils/constant/api.constant";

interface SecurityStatusResponse {
  isEnabled: boolean;
  lastChecked: string;
}

const fetchSecurityStatus = async (): Promise<SecurityStatusResponse> => {
  const response = await C_API.get(API_URLS.SETTING.SECURITY.STATUS);
  return response.data?.data;
};

export const useSecurityStatus = () => {
  return useQuery<SecurityStatusResponse, Error>({
    queryKey: ["securityStatus"],
    queryFn: fetchSecurityStatus,
    refetchInterval: 0,
    staleTime: 0,
  });
};

export const changePassword = async (data: any) => {
  const encryptData = Secure.payloadEncryption(data, { excludedKeys: ["token"] });
  try {
    const response = await C_API.post(API_URLS.SETTING.SECURITY.CHANGE_PASSWORD, encryptData);
    return { status: response.status, data: response.data };
  } catch (err) {
    return err;
  }
};

export const updateTempPassword = async (data: any) => {
  const encryptData = Secure.payloadEncryption(data, { excludedKeys: ["token"] });
  try {
    const response = await C_API.post(API_URLS.SETTING.SECURITY.UPDATE_PASSWORD, encryptData);
    return { status: response.status, data: response.data };
  } catch (err) {
    return err;
  }
};

export const verifyMfa = async (data: any) => {
  const encryptData = Secure.payloadEncryption(data);
  try {
    const response = await C_API.post(API_URLS.SETTING.SECURITY.MFA_VERIFY, encryptData);
    return { status: response.status, data: response.data };
  } catch (err) {
    return err;
  }
};

export const registeredMfa = async (data: any) => {
  const encryptData = Secure.payloadEncryption(data);
  try {
    const response = await C_API.post(API_URLS.SETTING.SECURITY.MFA_REGISTER, encryptData);
    return { status: response.status, data: response.data };
  } catch (err) {
    return err;
  }
};

export const toggledMfa = async (data: any) => {
  const encryptData = Secure.payloadEncryption(data);
  try {
    const response = await C_API.post(API_URLS.SETTING.SECURITY.MFA_TOGGLE, encryptData);
    return { status: response.status, data: response.data };
  } catch (err) {
    return err;
  }
};

export const verifyPhone = async (data: any) => {
  const encryptData = Secure.payloadEncryption(data);
  try {
    const response = await C_API.post(API_URLS.SETTING.SECURITY.VERIFY_PHONE, encryptData);
    return { status: response.status, data: response.data };
  } catch (err) {
    return err;
  }
};

export const sendPhoneOTP = async () => {
  try {
    const response = await C_API.get(API_URLS.SETTING.SECURITY.SEND_PHONE_OTP);
    return { status: response.status, data: response.data };
  } catch (err) {
    return err;
  }
};
export const fetchPassCheckReq = async (): Promise<SecurityStatusResponse> => {
  const response = await C_API.get(API_URLS.ACTIONS.PASS_CHECK_REQ);
  return response.data?.data;
};

export const verifyPassCheck = async (data: any) => {
  const encryptData = Secure.payloadEncryption(data, { excludedKeys: ["token"] });
  try {
    const response = await C_API.post(API_URLS.ACTIONS.PASS_CHECK, encryptData);
    return { status: response.status, data: response.data };
  } catch (err) {
    return err;
  }
};

export const sendChangePhoneOTP = async (data: any) => {
  const encryptData = Secure.payloadEncryption(data);
  try {
    const response = await C_API.post(API_URLS.SETTING.SECURITY.SEND_CHANGE_PHONE_OTP, encryptData);
    return { status: response.status, data: response.data };
  } catch (err) {
    return err;
  }
};

export const verifyChangePhoneOTP = async (data: any) => {
  const encryptData = Secure.payloadEncryption(data);
  try {
    const response = await C_API.post(API_URLS.SETTING.SECURITY.VERIFY_CHANGE_PHONE, encryptData);
    return { status: response.status, data: response.data };
  } catch (err) {
    return err;
  }
};

export const privateResendCode = async (data: any, param: string = "") => {
  let apiUrl = API_URLS.SETTING.SECURITY.PRIVATE_RESEND;
  if (param) {
    apiUrl += param;
  }
  const encryptData = Secure.payloadEncryption(data);
  try {
    const response = await C_API.post(apiUrl, encryptData);
    return { status: response.status, data: response.data };
  } catch (err) {
    return err;
  }
};
